import { c as _c } from "react/compiler-runtime";
import { FormSelect } from '@systemeio/ui';
import EditActionWrapper from 'modules/automation-rules/actions/components/edit-actions/components/edit-action-wrapper';
import { EditActionItemInterface } from 'modules/automation-rules/actions/components/edit-actions/types/edit-action-item-interface';
import { ActionCampaignEditInterface } from 'modules/automation-rules/actions/types/automation-rule-actions-edit-interface';
import { getDataFromObj } from 'modules/automation-rules/utils/get-filter-data';
import { getCampaignStepsListNextjsUrl } from 'modules/campaigns/campaign-steps/utils/get-campaign-steps-list-nextjs-url';
import React from 'react';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { OpenInNewIcon } from '@systemeio/ui/icons';
interface ActionCampaignItemProps extends EditActionItemInterface<ActionCampaignEditInterface> {}
const ActionCampaignItem = t0 => {
  const $ = _c(15);
  const {
    actions,
    action,
    errors,
    setRules,
    onDelete,
    idx
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== idx || $[1] !== onDelete) {
    t1 = () => onDelete(idx);
    $[0] = idx;
    $[1] = onDelete;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== action.campaign || $[4] !== action.id || $[5] !== actions || $[6] !== errors.automationActions || $[7] !== idx || $[8] !== setRules || $[9] !== t) {
    t2 = t3 => {
      const {
        data,
        onOpen,
        renderActionLabel
      } = t3;
      return <><FormSelect onOpen={onOpen} label={renderActionLabel({
          label: t("dashboard.campaign.title"),
          additionalLabel: action.campaign.id ? <LinkWithoutPrefetch rel="noreferrer" target="_blank" className="group self-center outline-hidden" href={getCampaignStepsListNextjsUrl(action.campaign.id)}><OpenInNewIcon className="main-transition-colors group-focus-visible:fill-brand-primary hover:fill-brand-primary" /></LinkWithoutPrefetch> : undefined
        })} placeholder={t("dashboard.automation_rule.choose_campaign")} value={action.campaign.id} data={data.campaignData} staticData={getDataFromObj(action.campaign)} onChange={data_0 => setRules(prev => ({
          ...prev,
          actions: actions.map((el, i) => {
            if (idx === i) {
              return {
                ...el,
                campaign: {
                  id: data_0
                }
              };
            } else {
              return el;
            }
          })
        }))} error={errors.automationActions[action.id]?.campaign?.join("")} /></>;
    };
    $[3] = action.campaign;
    $[4] = action.id;
    $[5] = actions;
    $[6] = errors.automationActions;
    $[7] = idx;
    $[8] = setRules;
    $[9] = t;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== action.type || $[12] !== t1 || $[13] !== t2) {
    t3 = <EditActionWrapper slug={action.type} onDelete={t1}>{t2}</EditActionWrapper>;
    $[11] = action.type;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
};
export default ActionCampaignItem;